import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, HasId, UserTour, UserTourStep, UserTourWithCompletion } from '../../model';
import { buildQuery } from '../../util';

@Injectable({ providedIn: 'root' })
export class UserTourService extends _Service<UserTour> {
  constructor() {
    super('api/user-tour');
  }

  createStep = async (tourId: string, step: UserTourStep) =>
    this.http.post<HasId>(`${this.prefix}/${tourId}/step`, step);

  updateStep = async (tourId: string, stepId: AppId, step: UserTourStep) =>
    this.http.put<HasId>(`${this.prefix}/${tourId}/step/${stepId}`, step);

  deleteStep = async (tourId: string, stepId: string) => this.http.delete(`${this.prefix}/${tourId}/step/${stepId}`);

  localizedDetail = async (tour: string, language: 'en' | 'de' | 'zh' | 'es') =>
    this.http.get<UserTourWithCompletion>(`${this.prefix}/localized` + buildQuery({ tour, language }));
}
